/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { NoData } from "./models";

export class SightlineApiPublisher {
  constructor(private caller: ApiCaller) {}

  async messageStopped(payload: NoData, sessionId: string, messageId: string): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.sightline.v1.sessions.${sessionId}.messages.${messageId}.stopped",
        variables: { sessionId: String(sessionId), messageId: String(messageId) },
      },
      "messageStopped",
      payload,
      { publish: true },
    );
  }
}
